// extracted by mini-css-extract-plugin
export var cardIcon = "_6t-5";
export var cardIconUnframed = "_6t-9";
export var checkboxCard = "_6t-0";
export var checkboxCardSelected = "_6t-4";
export var disabled = "_6t-2";
export var interactive = "_6t-1";
export var outerBorder = "_6t-3";
export var spacerMedium = "_6t-8";
export var spacerSmall = "_6t-7";
export var spacerXsmall = "_6t-6";